'use client';

import AnnualIncome from '@/components/react-hook-form/AnnualIncome';
import { useFormContext, Controller } from 'react-hook-form';
import type { FormSchema } from '@/app/register/schema';
import { SelectItem } from '@/components/shadcn/Select';
import { useMemo } from 'react';
import { registerTextStyle } from '@/app/register/constants';
import { buildUpdateUserCareerParams } from '../functions';
import { updateUserCareer } from '../../../actions/user';
import RegisterLayout from '../components/RegisterLayout';
import getKeys from '../../../utils/getKeys';
import FirebasePageViewEvent from '@/components/firebase/PageViewEvent';
import { EVENTS } from '@/lib/firebase/analytics/events';

export const createOptions = () =>
  Array.from({ length: 18 }).map((_, i) => (
    <SelectItem key={i} value={String((i + 1) * 50 + 100)}>
      {`${(i + 1) * 50 + 100}万円`}
    </SelectItem>
  ));

export default function AnnualIncomeForm() {
  const { control, watch } = useFormContext<FormSchema>();

  const jobExperience = watch('jobexperience');

  const prevPage = getKeys(jobExperience).some(category => {
    return !!jobExperience[category].length;
  })
    ? 'experiencelevels'
    : 'jobexperience';

  const annualIncomeElements = useMemo(createOptions, []);

  const updateAnnualIncome = () => {
    const annualIncome = watch('annualincome');
    const params = buildUpdateUserCareerParams({
      annualincome: annualIncome
    });
    return updateUserCareer(params);
  };

  return (
    <>
      <h3 className={registerTextStyle}>
        <span className="text-[20px] text-[#231717]">現在の年収</span>
        を教えてください
      </h3>
      <RegisterLayout
        prev={prevPage}
        next="jobchangeintention"
        updateProfile={updateAnnualIncome}
      >
        <div className="mx-auto mt-[24px] max-w-[672px]">
          <Controller
            control={control}
            name="annualincome"
            render={({ field: { value, onChange } }) => (
              <AnnualIncome
                value={value}
                onChange={onChange}
                optionElements={annualIncomeElements}
                placeholder="例：400万円"
                className="w-full"
              />
            )}
          />
        </div>
      </RegisterLayout>

      {/* Firebaseイベント発火 */}
      <FirebasePageViewEvent
        eventName={EVENTS.registration_annual_income_display}
      />
    </>
  );
}
